import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import StudyBotNavbar from '../components/Navbar';
import '../styles/DocumentsPage.css';

function DocumentsPage() {
  const [showModal, setShowModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const documents = [
    { 
      id: 1, 
      title: 'StudyBot User Guide', 
      description: 'Comprehensive guide to using StudyBot',
      type: 'PDF'
    },
    { 
      id: 2, 
      title: 'AI Learning Methodology', 
      description: 'Insights into our adaptive learning approach',
      type: 'White Paper'
    },
    { 
      id: 3, 
      title: 'Privacy Policy', 
      description: 'How we protect your data and learning information',
      type: 'Legal Document'
    }
  ];

  const handleDocumentView = (doc) => {
    setSelectedDocument(doc);
    setShowModal(true);
  };

  return (
    <div>
      <StudyBotNavbar />
      <Container className="documents-page">
        <h1 className="text-center mb-5">StudyBot Documents</h1>
        <Row>
          {documents.map(doc => (
            <Col md={4} key={doc.id} className="mb-4">
              <Card className="document-card">
                <Card.Body>
                  <Card.Title>{doc.title}</Card.Title>
                  <Card.Text>{doc.description}</Card.Text>
                  <Card.Footer className="d-flex justify-content-between align-items-center">
                    <span className="document-type">{doc.type}</span>
                    <Button 
                      variant="primary" 
                      size="sm" 
                      onClick={() => handleDocumentView(doc)}
                    >
                      View
                    </Button>
                  </Card.Footer>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{selectedDocument?.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedDocument && (
              <div>
                <p>{selectedDocument.description}</p>
                <p>Document Type: {selectedDocument.type}</p>
                <p className="text-muted">
                  Note: Actual document content would be loaded here in a real application.
                </p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
}

export default DocumentsPage;
